import React from 'react';
import { auditStatus } from '../../ui';
import JobList from './JobList';

const Audits = () => (
  <JobList
    title="Audits"
    subtitle="Site visits booked by customers, from vendor assignment to an accepted quote."
    endpoint="/audit/all_audits"
    idKey="audit_id"
    statusOf={auditStatus}
    detailPath="/audits/manage-audit"
    groups={[['Needs a vendor', [0]], ['In progress', [1, 2, 3, 4]], ['Awaiting customer', [5]], ['Accepted', [6]], ['Cancelled', [-1, -2, -3]]]}
    dateLabel="Visit date"
  />
);

export default Audits;
